<template>
  <div class="upload-single">
    <el-upload
      class="avatar-uploader"
      list-type="picture-card"
      :show-file-list="false"
      :disabled="isDisabled"
      :on-error="err"
      :on-progress="progress"
      :action="uploadAction"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />

      <template v-else>
        <i class="el-icon-plus avatar-uploader-icon" :disabled="isDisabled">
          <slot name="upload-tip">
            <div class="el-upload__tip">上传文件</div>
          </slot>
        </i>
      </template>
    </el-upload>
    <template v-if="imageUrl">
      <div class="shadow">
        <div class="shadow-ic">
          <i class="ic-del" @click="handleDel"></i>
          <i class="ic-look" @click="showViewer($event)"> <img :src="imageUrl" style="display: none" /></i>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api/base.new.api';
import { WUYI, vali } from '@/api/common';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import { Loading, Message } from 'element-ui';
import { getFileUrlPrefix } from '@/utils';
var loading;
export default {
  data() {
    return {
      imageUrl: '',
      isDisabled: false, // 是否禁止图片上传
      uploadAction: api.newUploadImg,
      viewer: null,
      urlPrefix: ''
    };
  },
  props: {
    currentImgName: {
      type: String,
      required: true
    },
    currentImgVal: {
      type: String,
      default: ''
    }
  },
  async created() {
    this.urlPrefix = await getFileUrlPrefix();
    if (this.currentImgVal) {
      if (this.currentImgVal.indexOf(this.urlPrefix) != -1) {
        this.imageUrl = this.currentImgVal;
      } else {
        this.imageUrl = `${this.urlPrefix}${this.currentImgVal}`;
      }
    }
  },
  watch: {
    currentImgVal(val) {
      if (val) {
        this.imageUrl = `${this.urlPrefix}${val}`;
      } else {
        this.imageUrl = '';
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      if (res.code != 0) {
        loading.close();
        this.$message.error(res.message);
        this.isDisabled = false;
        return false;
      }
      const name = file.name;
      const url = res.data.fileUri;
      const pic = URL.createObjectURL(file.raw);
      const data = {
        name,
        url
      };
      let currentImgObj = { source: this.currentImgName, data };
      this.$emit('succeed', currentImgObj, () => {
        loading.close();
        this.isDisabled = false;
      });
    },
    err(err, file, fileList) {
      loading.close();
      this.isDisabled = false;
      this.$message.error('图片上传失败!');
    },
    beforeAvatarUpload(file) {
      console.log('beforeAvatarUpload');
      const isJPEG = file.type === 'image/jpeg';
      const isJPG = file.type === 'image/jpg';
      const isPNG = file.type === 'image/png';
      const isSize = file.size / 1024 / 1024 < vali.imgLimit;
      if (!isJPEG && !isJPG && !isPNG) {
        this.$message.error('支持PNG、JPG、JPEG等图片格式!');
        return false;
      }
      if (!isSize) {
        this.$message.error(`上传图片大小不能超过 ${vali.imgLimit}MB!`);
        return false;
      }
      loading = Loading.service({
        fullscreen: true,
        text: '上传中...'
      });
    },
    progress(event, file, fileList) {
      this.isDisabled = true;
    },
    // 点击预览大图
    showViewer(event) {
      if (!this.viewer) {
        this.viewer = new Viewer(event.target);
      }
      this.viewer.show();
    },
    // 删除已上传的图片
    handleDel(picUrl) {
      this.$emit('remove', this.currentImgName);
    }
  }
};
</script>

<style scoped>
.upload-single {
  position: relative;
  width: 192px;
  height: 120px;
}
.avatar-uploader {
  width: 192px;
  height: 120px;
  background: #eef4f7;
}
.avatar {
  width: 98px;
  height: 98px;
  display: block;
}
.shadow {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7;
  z-index: 99;
}
.upload-single:hover .shadow {
  display: block;
  text-align: center;
}
.shadow-ic {
  width: 58px;
  height: 24px;
  margin: 0 auto;
  margin-top: 38px;
}
.shadow .ic-del {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: url('../assets/img/ic_del.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.shadow .ic-look {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: url('../assets/img/ic_look.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.el-upload:hover .shadow {
  display: block;
  text-align: center;
}
</style>
<style>
.upload-single .el-upload--picture-card {
  width: 192px;
  height: 120px;
  background: #f8fafb;
  border: 1px solid #eef4f7;
  box-sizing: border-box;
}
.upload-single .el-upload--picture-card img {
  width: 190px;
  height: 118px;
}
.upload-single .el-upload--picture-card i {
  vertical-align: middle;
  color: #b3c0cf !important;
}
.upload-single .el-upload__tip {
  color: #c4cbd2;
  font-size: 14px;
}
</style>
